import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import URLS from "@api/constants/urls";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useCertificateTemplateService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";
  const allCertificateTemplatesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CERTIFICATE_TEMPLATES,
      page,
      per_page,
      debouncedQuery,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CERTIFICATE_TEMPLATES,
        searchParams: {
          page,
          per_page,
          "filter[created_between]": created_between,
        },
      }),
    enabled: enableQuery,
  });

  return {
    service: { allCertificateTemplatesService },
    states: { searchQuery, setSearchQuery },
  };
};
